import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Alert, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  Person as PersonIcon,
  Phone as PhoneIcon,
  Business as BusinessIcon,
  LocationCity as LocationCityIcon,
  Percent as PercentIcon,
  Save as SaveIcon
} from '@mui/icons-material';
import { useAuth } from '../auth/Auth';

const FinalRegistration = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const [username, setUsername] = useState('');
  const [phone, setPhone] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [city, setCity] = useState('');
  const [discount, setDiscount] = useState('');
  
  
  const [citySearch, setCitySearch] = useState('');
  const [filteredCities, setFilteredCities] = useState([]);
  const [showCityDropdown, setShowCityDropdown] = useState(false);
  const [allCities, setAllCities] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const cityRef = useRef(null);
  
  const [usernameError, setUsernameError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [companyError, setCompanyError] = useState('');
  const [cityError, setCityError] = useState('');
  
  const [isFormValid, setIsFormValid] = useState(false);
  const [isCompanyCreated, setIsCompanyCreated] = useState(false);
  const [createdContractorId, setCreatedContractorId] = useState(null);
  
  
  const fetchAllCities = async () => {
    setLoadingCities(true);
    try {
      const response = await axios.get('https://test2.planfix-to-syrve.com/api/all-cities');
      if (response.data.success) {
        setAllCities(response.data.data);
      }
    } catch (error) {
      console.error('Помилка завантаження міст:', error);
    } finally {
      setLoadingCities(false);
    }
  };
  
  
  const searchCities = async (searchTerm) => {
    if (!searchTerm || searchTerm.trim() === '') {
      setFilteredCities([]);
      setShowCityDropdown(false);
      return;
    }
    
    try {
      const response = await axios.get(`https://test2.planfix-to-syrve.com/api/cities?search=${encodeURIComponent(searchTerm)}`);
      if (response.data.success) {
        setFilteredCities(response.data.data);
        setShowCityDropdown(response.data.data.length > 0);
      }
    } catch (error) {
      console.error('Помилка пошуку міст:', error);
    }
  };
  
  
  const formatPhoneNumber = (digits) => {
    if (digits.length === 0) return '';
    
    if (digits.length <= 3) {
      if (digits === '3' || digits === '38' || digits === '380') {
        return `+${digits}`;
      }
      return '+380';
    }
    
    if (digits.length <= 5) {
      const operator = digits.slice(3, 5);
      return `+380 (${operator}`;
    }
    
    if (digits.length <= 8) {
      const operator = digits.slice(3, 5);
      const part1 = digits.slice(5, 8);
      return `+380 (${operator}) ${part1}`;
    }
    
    if (digits.length <= 10) {
      const operator = digits.slice(3, 5);
      const part1 = digits.slice(5, 8);
      const part2 = digits.slice(8, 10);
      return `+380 (${operator}) ${part1}-${part2}`;
    }
    
    const operator = digits.slice(3, 5);
    const part1 = digits.slice(5, 8);
    const part2 = digits.slice(8, 10);
    const part3 = digits.slice(10, 12);
    return `+380 (${operator}) ${part1}-${part2}-${part3}`;
  };

  useEffect(() => {
    const fetchUserData = async () => {
      if (!user?.user_id) {
        navigate('/Login');
        return;
      }
      
      try {
        setLoading(true);
        const response = await axios.get(`https://test2.planfix-to-syrve.com/users-admin`);
        const userData = response.data.find(u => u.id === parseInt(user.user_id));
        
        if (userData) {
          setUsername(userData.username || '');
          
          const rawPhone = userData.token || '';
          const digitsOnly = rawPhone.replace(/\D/g, '');
          let correctedDigits = digitsOnly;
          if (!correctedDigits.startsWith('380')) {
            if (correctedDigits.startsWith('0')) {
              correctedDigits = '38' + correctedDigits;
            } else if (correctedDigits.startsWith('+38')) {
              correctedDigits = correctedDigits.replace('+38', '380');
            } else if (correctedDigits.startsWith('8')) {
              correctedDigits = '380' + correctedDigits.slice(1);
            } else {
              correctedDigits = '380' + correctedDigits;
            }
          }
          const formattedPhone = formatPhoneNumber(correctedDigits);
          setPhone(formattedPhone);
          
          setDiscount(userData.discount?.toString() || '');
          
          if (userData.city) {
            setCity(userData.city);
            setCitySearch(userData.city);
          }
          
          if (userData.contractor_id) {
            try {
              const contractorResponse = await axios.get(`https://test2.planfix-to-syrve.com/contractors`);
              const contractor = contractorResponse.data.find(c => c.id === userData.contractor_id);
              if (contractor) {
                setCompanyName(contractor.name || '');
                setCreatedContractorId(contractor.id);
                setIsCompanyCreated(true);
              }
            } catch (err) {
              console.error('Error fetching contractor:', err);
            }
          }
        }
      } catch (err) {
        console.error('Error fetching user data:', err);
        setError('Помилка при завантаженні даних');
      } finally {
        setLoading(false);
      }
    };
    
    fetchUserData();
    fetchAllCities();
  }, [user, navigate]);

  
  const handleCityChange = (e) => {
    const value = e.target.value;
    setCitySearch(value);
    setCity(value);
    searchCities(value);
    validateCity(value);
  };
  
  
  const handleCitySelect = (selectedCity) => {
    setCity(selectedCity);
    setCitySearch(selectedCity);
    setShowCityDropdown(false);
    validateCity(selectedCity);
  };
  
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cityRef.current && !cityRef.current.contains(event.target)) {
        setShowCityDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const isValid = 
      username.trim() !== '' &&
      phone.trim() !== '' &&
      companyName.trim() !== '' &&
      city.trim() !== '' &&
      !usernameError &&
      !phoneError &&
      !companyError &&
      !cityError;
    
    setIsFormValid(isValid);
  }, [username, phone, companyName, city, usernameError, phoneError, companyError, cityError]);

  const validateUsername = (value) => {
    if (!value.trim()) {
      setUsernameError("ПІБ користувача обов'язкове");
    } else if (value.length < 3) {
      setUsernameError("ПІБ користувача має містити мінімум 3 символи");
    } else {
      setUsernameError('');
    }
  };

  const validatePhone = (value) => {
    const digitsOnly = value.replace(/\D/g, '');
    
    if (!digitsOnly) {
      setPhoneError("Номер телефону обов'язковий");
      return false;
    }
    
    if (!digitsOnly.startsWith('380')) {
      setPhoneError("Номер має починатися з +380");
      return false;
    }
    
    if (digitsOnly.length < 12) {
      setPhoneError(`Введіть ще ${12 - digitsOnly.length} цифр (всього 9 цифр після +380)`);
      return false;
    }
    
    if (digitsOnly.length > 12) {
      setPhoneError("Номер телефону занадто довгий");
      return false;
    }
    
    setPhoneError('');
    return true;
  };

  const validateCompany = (value) => {
    if (!value.trim()) {
      setCompanyError("Назва компанії обов'язкова");
    } else {
      setCompanyError('');
    }
  };

  const validateCity = (value) => {
    if (!value.trim()) {
      setCityError("Місто обов'язкове");
    } else {
      setCityError('');
    }
  };

  const handleUsernameChange = (e) => {
    const value = e.target.value;
    setUsername(value);
    validateUsername(value);
  };

  const handlePhoneChange = (e) => {
    let inputValue = e.target.value;
    let digits = inputValue.replace(/\D/g, '');
    
    if (digits.length > 0) {
      if (!digits.startsWith('380')) {
        if (digits.startsWith('0')) {
          digits = '38' + digits;
        } else if (digits.length >= 3) {
          digits = '380' + digits;
        } else if (digits.length === 1 && digits !== '3') {
          digits = '3';
        } else if (digits.length === 2 && digits !== '38') {
          digits = '38';
        }
      }
    }
    
    let limitedDigits = digits.slice(0, 12);
    
    if (limitedDigits.length === 1 && limitedDigits !== '3') {
      limitedDigits = '3';
    }
    if (limitedDigits.length === 2 && limitedDigits !== '38') {
      limitedDigits = '38';
    }
    if (limitedDigits.length === 3 && limitedDigits !== '380') {
      limitedDigits = '380';
    }
    
    const formattedValue = formatPhoneNumber(limitedDigits);
    setPhone(formattedValue);
    validatePhone(formattedValue);
  };

  const handleCompanyChange = (e) => {
    const value = e.target.value;
    setCompanyName(value);
    validateCompany(value);
  };

  const updateUserRoleFile = async (userId, newRole) => {
    try {
      await axios.post(`https://test2.planfix-to-syrve.com/api/sync-user-role/${userId}`, {
        role: newRole
      });
      return true;
    } catch (err) {
      console.error('Error updating role file:', err);
      return false;
    }
  };

const handleSaveAll = async () => {
  if (!isFormValid) {
    setError('Будь ласка, заповніть всі обов\'язкові поля');
    return;
  }

  setLoading(true);
  setError('');
  setSuccess('');

  try {
    const userId = user.user_id;
    
    
    let cleanPhone = phone.replace(/\D/g, '');
    if (!cleanPhone.startsWith('380')) {
      cleanPhone = '380' + cleanPhone;
    }
    
    
    if (cleanPhone.length > 12) {
      cleanPhone = cleanPhone.slice(0, 12);
    }
    
    
    const phoneWithPlus = '+' + cleanPhone;
    
    console.log('Зберігаємо телефон (з +):', phoneWithPlus);
    
    const response = await axios.post('https://test2.planfix-to-syrve.com/final-registration-complete', {
      user_id: userId,
      username: username.trim(),
      token: phoneWithPlus, 
      city: city.trim(),
      company_name: companyName.trim()
    });
    
    console.log('Відповідь сервера:', response.data);
    
    if (response.data.success) {
      localStorage.setItem('userRole', '0');
      localStorage.setItem('userId', userId);
      
      setSuccess('Реєстрацію успішно завершено!');
      
      setTimeout(() => {
        window.location.href = '/DutyPage';
      }, 1500);
    } else {
      setError(response.data.message || 'Помилка при завершенні реєстрації');
    }
    
  } catch (err) {
    console.error('ПОМИЛКА:', err);
    setError(err.response?.data?.message || 'Помилка при оновленні');
  } finally {
    setLoading(false);
  }
};

  if (loading && !username) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <CircularProgress />
    </div>;
  }

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '800px', 
      margin: '0 auto', 
      backgroundColor: '#f5f5f5', 
      minHeight: '100vh' 
    }}>
      <div style={{ 
        backgroundColor: 'white', 
        borderRadius: '10px', 
        padding: '30px', 
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        maxWidth: '600px',
        margin: '0 auto'
      }}>
        <h2 style={{ margin: '0 0 25px 0', color: '#333', fontSize: '24px', textAlign: 'center' }}>
          Завершення реєстрації
        </h2>

        {error && <Alert severity="error" style={{ marginBottom: '20px' }}>{error}</Alert>}
        {success && <Alert severity="success" style={{ marginBottom: '20px' }}>{success}</Alert>}

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', color: '#666', fontWeight: '500', textAlign: 'center' }}>
            ПІБ користувача: <span style={{ color: '#dc3545' }}>*</span>
          </label>
          <input
            type="text"
            value={username}
            onChange={handleUsernameChange}
            style={{
              width: '100%',
              padding: '10px 12px',
              border: usernameError ? '2px solid #dc3545' : '1px solid #dee2e6',
              borderRadius: '6px',
              fontSize: '14px',
              boxSizing: 'border-box',
              textAlign: 'center'
            }}
          />
          {usernameError && <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px', textAlign: 'center' }}>{usernameError}</div>}
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', color: '#666', fontWeight: '500', textAlign: 'center' }}>
            Номер телефону: <span style={{ color: '#dc3545' }}>*</span>
          </label>
          <input
            type="tel"
            value={phone}
            onChange={handlePhoneChange}
            placeholder="+380 (93) 805-27-58"
            style={{
              width: '100%',
              padding: '10px 12px',
              border: phoneError ? '2px solid #dc3545' : '1px solid #dee2e6',
              borderRadius: '6px',
              fontSize: '14px',
              boxSizing: 'border-box',
              fontFamily: 'monospace',
              textAlign: 'center'
            }}
          />
          {phoneError && <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px', textAlign: 'center' }}>{phoneError}</div>}
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', color: '#666', fontWeight: '500', textAlign: 'center' }}>
            Компанія: <span style={{ color: '#dc3545' }}>*</span>
          </label>
          <input
            type="text"
            value={companyName}
            onChange={handleCompanyChange}
            style={{
              width: '100%',
              padding: '10px 12px',
              border: companyError ? '2px solid #dc3545' : '1px solid #dee2e6',
              borderRadius: '6px',
              fontSize: '14px',
              boxSizing: 'border-box',
              textAlign: 'center'
            }}
          />
          {companyError && <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px', textAlign: 'center' }}>{companyError}</div>}
        </div>

        {}
        <div style={{ marginBottom: '20px' }} ref={cityRef}>
          <label style={{ display: 'block', marginBottom: '8px', color: '#666', fontWeight: '500', textAlign: 'center' }}>
            Місто: <span style={{ color: '#dc3545' }}>*</span>
          </label>
          <div className="city-combobox" style={{ position: 'relative' }}>
            <input
              type="text"
              value={citySearch}
              onChange={handleCityChange}
              onFocus={() => {
                if (citySearch && filteredCities.length > 0) {
                  setShowCityDropdown(true);
                }
              }}
              placeholder="Введіть назву міста або виберіть зі списку..."
              style={{
                width: '100%',
                padding: '10px 12px',
                border: cityError ? '2px solid #dc3545' : '1px solid #dee2e6',
                borderRadius: '6px',
                fontSize: '14px',
                boxSizing: 'border-box',
                textAlign: 'center'
              }}
            />
            {showCityDropdown && filteredCities.length > 0 && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                maxHeight: '200px',
                overflowY: 'auto',
                backgroundColor: 'white',
                border: '1px solid #dee2e6',
                borderRadius: '6px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                zIndex: 1000,
                marginTop: '4px'
              }}>
                {filteredCities.map((cityName, index) => (
                  <div
                    key={index}
                    onClick={() => handleCitySelect(cityName)}
                    style={{
                      padding: '8px 12px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0',
                      fontSize: '14px',
                      textAlign: 'center',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#f5f5f5';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'white';
                    }}
                  >
                    {cityName}
                  </div>
                ))}
              </div>
            )}
          </div>
          {cityError && <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px', textAlign: 'center' }}>{cityError}</div>}
          {loadingCities && <div style={{ color: '#999', fontSize: '12px', marginTop: '4px', textAlign: 'center' }}>Завантаження списку міст...</div>}
        </div>

        {discount && (
          <div style={{ marginBottom: '30px', textAlign: 'center' }}>
            <label style={{ display: 'block', marginBottom: '8px', color: '#666', fontWeight: '500' }}>
              Ваша знижка: <span style={{ color: '#111111' }}>{discount}%</span>
            </label>
          </div>
        )}

        <button
          onClick={handleSaveAll}
          disabled={!isFormValid || loading}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: isFormValid && !loading ? '#edec5b' : '#ccc',
            color: isFormValid && !loading ? '#333' : '#666',
            border: 'none',
            borderRadius: '6px',
            cursor: isFormValid && !loading ? 'pointer' : 'not-allowed',
            fontSize: '16px',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          {loading ? <CircularProgress size={20} /> : <>Завершити реєстрацію</>}
        </button>
      </div>
    </div>
  );
};

export default FinalRegistration;
